<template>
    <el-dropdown ref="dropdown" placement="top-start" trigger="click" :disabled="!canSendGift">
        <span class="el-dropdown-link" :class="{ disabled: !canSendGift }">
            <img class="icon pointer" src="@/assets/theGift.png" alt="礼物" title="礼物">
        </span>
        <el-dropdown-menu slot="dropdown" class="picker-dropdown">
            <div class="picker-container">
                <div class="tabs-container">
                    <el-tabs v-model="activeTabIndex" class="picker-tabs" @tab-click="handleTabClick" :stretch="false">
                        <el-tab-pane v-for="(categoryName, index) in tabList" :key="index" :label="categoryName"
                            :name="index + ''">
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="content-container">
                    <div class="gift-grid">
                        <div v-for="(item, index) in currentGifts" :key="index" class="gift-item"
                            @click="onGiftClick(item)" :class="{ disabled: item.disabled }">
                            <img class="gift-image" :src="item.url" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    name: 'GiftPicker',
    props: {
        // 简化的数据结构: ['category1', 'category2', ...]
        categoryList: {
            type: Array,
            default: () => []
        },
        // 当前分类的礼物列表: [{ url: 'xx', disabled: false, ...}]
        giftList: {
            type: Array,
            default: () => []
        },
        // 是否可以发送礼物
        canSendGift: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            activeTabIndex: '0'
        }
    },
    computed: {
        tabList() {
            return this.categoryList || [];
        },
        currentGifts() {
            return this.giftList || [];
        }
    },
    watch: {
        // 监听分类列表变化，重置为第一个tab
        categoryList() {
            if (this.categoryList.length > 0) {
                this.activeTabIndex = '0';
            }
        }
    },
    methods: {
        handleTabClick(tab) {
            this.activeTabIndex = tab.name;
            const categoryName = this.tabList[parseInt(tab.name)];
            this.$emit('category-change', categoryName, parseInt(tab.name));
        },
        onGiftClick(gift) {
            if (!gift.disabled && this.canSendGift) {
                this.$emit('gift-select', gift);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.icon {
    width: 22px;
    height: 22px;
    margin-right: 20px;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.el-dropdown-link {
    cursor: pointer;

    &.disabled {
        cursor: not-allowed;
        opacity: 0.5;

        .icon {
            filter: grayscale(100%);

            &:hover {
                transform: none;
            }
        }
    }
}

.picker-dropdown {
    width: 420px;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border: 1px solid #e4e7ed;
    overflow: hidden;
}

.picker-container {
    background: #fff;
}

.tabs-container {
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
    padding: 8px;
}

.picker-tabs {
    ::v-deep .el-tabs__header {
        margin: 0;
        border: none;
    }

    ::v-deep .el-tabs__nav-wrap {
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;
        border: none;
        position: relative;
        height: 48px;
        display: flex;
        align-items: center;
        padding: 0 30px;

        &::-webkit-scrollbar {
            display: none;
        }

        &::after {
            height: 0;
        }
    }

    ::v-deep .el-tabs__nav {
        border: none;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 0 4px;
    }

    ::v-deep .el-tabs__item {
        min-width: max-content;
        max-width: none;
        white-space: normal !important;
        text-overflow: unset !important;
        overflow: visible !important;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background: transparent;
        margin: 0 2px;
        border-radius: 8px;
        transition: all 0.2s ease;
        position: relative;
        font-size: 12px;

        &:hover {
            background: #f0f0f0;
        }

        &.is-active {
            background: transparent;
            color: #409EFF;
            border-bottom: none;
        }

        &.is-active::after {
            content: '';
            display: block;
            position: absolute;
            left: 20%;
            right: 20%;
            bottom: 0;
            height: 3px;
            border-radius: 2px;
            background: #409EFF;
        }
    }

    ::v-deep .el-tabs__active-bar {
        display: none;
    }

    ::v-deep .el-tabs__nav-next,
    ::v-deep .el-tabs__nav-prev {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        background: rgba(255, 255, 255, 0.95);
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.2s ease;
        z-index: 10;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        &:hover {
            background: #fff;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        // &.is-disabled {
        //     opacity: 0.3;
        //     cursor: not-allowed;
        // }
    }

    ::v-deep .el-tabs__nav-prev {
        left: 4px;
    }

    ::v-deep .el-tabs__nav-next {
        right: 4px;
    }
}

.content-container {
    padding: 12px;
    background: #fff;
}

.gift-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));
    gap: 8px;
    max-height: 180px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.gift-item {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 5px;

    &:hover:not(.disabled) {
        background: #f0f8ff;
        transform: scale(1.05);
    }

    &:active:not(.disabled) {
        transform: scale(0.95);
    }

    &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }
}

.gift-image {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: 4px;
}
</style>